import { MecProduct } from '@adapters/bigcommerce/types/product';

const klaviyoProductView = (product: MecProduct, url: string) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { _learnq = [] } = window;

  const splitUrl = url.split('/') ?? null;
  const indexOfProductMecId = splitUrl.indexOf('product') + 1 || null;
  const item = {
    ProductName: product.name,
    ProductID: (indexOfProductMecId && splitUrl[indexOfProductMecId]) ?? null,
    // SKU: 'WINNIEPOOH', // won't have as multiple variant - TODO address comments or clean up after confirming with Klaviyo
    Categories: product.categories,
    ImageURL: product.images[0]?.urlOriginal, // or should we filter to first isDefault?
    URL: url,
    Brand: product?.brand?.name ?? 'None provided',
    Price: product.price.highPrice?.value ?? 0.0,
  };
  _learnq.push(['track', 'Viewed Product', item]);
};

export default klaviyoProductView;
